module.exports = __webpack_public_path__ + "media/components/donate_now/static/donate_bg-bb8e4cd884c74e0a5e5abd720e76d465.jpg";